/**
 * Skrill brand mark — a purple gradient pill with the Skrill wordmark.
 * Used on the withdraw method pills and the pending-requests rows.
 */
export function SkrillLogo({ width = 58, height = 26 }: { width?: number; height?: number }) {
  return (
    <svg role="img" aria-label="Skrill" width={width} height={height} viewBox="0 0 58 26" fill="none">
      <defs>
        <linearGradient id="skrill-pill" x1="0" y1="0" x2="58" y2="26" gradientUnits="userSpaceOnUse">
          <stop style={{ stopColor: 'var(--color-brand-skrill-from)' }} />
          <stop offset="1" style={{ stopColor: 'var(--color-brand-skrill-to)' }} />
        </linearGradient>
      </defs>
      <rect width="58" height="26" rx="13" fill="url(#skrill-pill)" />
      <text
        x="29"
        y="18"
        textAnchor="middle"
        fontSize="13"
        fontWeight="700"
        fontStyle="italic"
        fontFamily="'Outfit', sans-serif"
        className="fill-brand-card-light"
        letterSpacing="-0.3"
      >
        Skrill
      </text>
    </svg>
  );
}
